// Central i18n dictionary — English, Hindi, Kannada
export const dict = {
  en: {
    nav: { home: "Home", products: "Products", gallery: "Gallery", about: "About", notice: "Notice", contact: "Contact" },
    hero: {
      eyebrow: "Est. Lingsugur · Karnataka",
      brand: "Ramdev Steel Furniture",
      brand2: "& Fabrication",
      sub: "Stainless steel gates, railings, safety doors, windows, swings and bespoke furniture — engineered in our Lingsugur workshop to outlast fashion.",
      view: "View Collections",
      whatsapp: "Chat on WhatsApp",
      quote: "Request a Quote",
    },
    slider: { title: "Our Craft", sub: "A quick look at recent installations." },
    collections: { eyebrow: "Collections", title: "Explore every collection.", view: "View Collection", coming: "Photos coming soon" },
    marquee: ["Gates", "Railings", "Safety Doors", "Windows", "Stair Railings", "Swings", "Furniture", "Custom Fabrication"],
    why: {
      eyebrow: "Why Ramdev Steel",
      title: "Six principles behind every weld.",
      chapters: [
        { t: "Material honesty", d: "We work only with graded MS, SS 304/202 and cold-rolled sheet — no substitutions, no shortcuts." },
        { t: "Precision fabrication", d: "CNC cutting and jigged welding hold tolerances to a fraction of a millimetre." },
        { t: "Finish for decades", d: "Anti-rust primer, mirror-polish or PU top-coat — finishes tested for coastal and rural weather." },
        { t: "Site-fit guarantee", d: "Every gate, railing and grill is measured, dry-fit and re-checked before delivery." },
        { t: "One workshop, one team", d: "Nothing is outsourced. The hand that welds it is the hand that installs it." },
        { t: "Transparent pricing", d: "Itemised quotes — steel weight, finish, labour and freight, no hidden add-ons." },
      ],
    },
    stats: { eyebrow: "In Numbers", items: [
      { k: "18+", v: "Years of craft" }, { k: "1200+", v: "Installations" },
      { k: "50+", v: "Villages & towns" }, { k: "100%", v: "Client-approved" },
    ]},
    cta: { title: "Ready to build something that lasts?", sub: "Send us the drawing, or just the idea. We'll take it from there.", btn: "Start a Project" },
    footer: { rights: "All rights reserved.", tagline: "Steel Furniture & Fabrication · Lingsugur, Karnataka" },
    products: { eyebrow: "The Catalogue", title: "Products", sub: "Filter by collection. Every piece is built to order, in our Lingsugur workshop.", all: "All", enquire: "Enquire" },
    gallery: { eyebrow: "Portfolio", title: "Gallery", sub: "A selection of completed installations from our workshop and site." },
    about: {
      eyebrow: "About",
      title: "A workshop. A family. A craft.",
      p1: "Ramdev Steel began as a small welding shop in Lingsugur and has grown into a full-service steel fabrication studio serving homes, farms and commercial sites across Karnataka.",
      p2: "We believe steel is not a commodity — it is a material with grain, memory and weight. Our job is to shape it into things you'll pass on to the next generation.",
      values: [
        { t: "Quality workmanship", d: "Every joint is inspected, every finish is tested." },
        { t: "Durable materials", d: "Only graded steel and industrial-grade finishes." },
        { t: "Modern designs", d: "Contemporary geometry, classical craft." },
        { t: "Customer first", d: "Site visits, honest advice, no upsell." },
      ],
    },
    notice: { eyebrow: "Announcements", title: "Notice Board", sub: "Offers, holidays and new-product launches from Ramdev Steel." },
    contact: {
      eyebrow: "Say Hello",
      title: "Let's build together.",
      sub: "Reach us on WhatsApp for the fastest response, or send an enquiry — we reply within one business day.",
      name: "Your name", phone: "Phone number", email: "Email", product: "Product required", message: "Tell us about your project",
      submit: "Send Enquiry", sending: "Sending…",
      success: "Enquiry received. We'll be in touch shortly.",
      error: "Something went wrong. Please try WhatsApp or call us.",
      addressLabel: "Workshop", phoneLabel: "Call", emailLabel: "Email", waLabel: "WhatsApp",
    },
    hours: {
      title: "Business Hours",
      openNow: "Open now", closedNow: "Closed now",
      mondaySaturday: "Monday – Saturday", sunday: "Sunday",
      timeWeekday: "9:00 AM – 8:00 PM", timeSunday: "9:00 AM – 8:00 PM",
      note: "Note: On some Sundays, the shop may remain closed. Please contact us on WhatsApp or call before visiting.",
    },
    faq: {
      eyebrow: "Questions",
      title: "Frequently asked.",
      items: [
        { q: "Do you deliver outside Lingsugur?", a: "Yes — we deliver and install across Raichur, Koppal, Ballari and neighbouring districts. Freight is quoted separately and transparently." },
        { q: "How long does a custom gate take?", a: "Typical lead-time is 10–14 working days from confirmed measurement, depending on design complexity and finish." },
        { q: "Do you offer maintenance?", a: "Yes — annual repaint and hinge servicing for anything we've built, at a fixed visit rate." },
        { q: "Can I bring my own design?", a: "Absolutely. Bring a sketch, a photograph, or a Pinterest link — we'll produce a to-scale drawing before we cut steel." },
      ],
    },
  },
  hi: {
    nav: { home: "होम", products: "उत्पाद", gallery: "गैलरी", about: "हमारे बारे में", notice: "सूचना", contact: "संपर्क" },
    hero: {
      eyebrow: "स्थापित · लिंगसुगुर, कर्नाटक",
      brand: "रामदेव स्टील फ़र्नीचर",
      brand2: "और फैब्रिकेशन",
      sub: "स्टेनलेस स्टील गेट, रेलिंग, सुरक्षा दरवाज़े, खिड़कियाँ, झूले और कस्टम फ़र्नीचर — लिंगसुगुर की हमारी वर्कशॉप में पीढ़ियों तक चलने के लिए बनाए गए।",
      view: "कलेक्शन देखें", whatsapp: "व्हाट्सएप पर चैट", quote: "कोटेशन",
    },
    slider: { title: "हमारा शिल्प", sub: "हाल की स्थापनाओं की एक झलक।" },
    collections: { eyebrow: "कलेक्शन", title: "हर कलेक्शन देखें।", view: "देखें", coming: "फ़ोटो जल्द ही" },
    marquee: ["गेट", "रेलिंग", "सुरक्षा दरवाज़े", "खिड़कियाँ", "सीढ़ी रेलिंग", "झूले", "फ़र्नीचर", "कस्टम फैब्रिकेशन"],
    why: {
      eyebrow: "क्यों रामदेव स्टील", title: "हर वेल्ड के पीछे छह सिद्धांत।",
      chapters: [
        { t: "सामग्री की ईमानदारी", d: "हम केवल ग्रेडेड MS, SS 304/202 और कोल्ड-रोल्ड स्टील का उपयोग करते हैं।" },
        { t: "सटीक फैब्रिकेशन", d: "CNC कटिंग और जिग-वेल्डिंग से मिलीमीटर की सटीकता।" },
        { t: "दशकों तक टिकाऊ फ़िनिश", d: "एंटी-रस्ट, मिरर-पॉलिश और PU टॉप-कोट।" },
        { t: "साइट-फ़िट गारंटी", d: "हर टुकड़ा नापा, ड्राई-फ़िट और जांचा जाता है।" },
        { t: "एक वर्कशॉप, एक टीम", d: "कुछ भी आउटसोर्स नहीं। जो वेल्ड करता है वही इंस्टॉल करता है।" },
        { t: "पारदर्शी मूल्य", d: "आइटमाइज़्ड कोटेशन — कोई छिपा शुल्क नहीं।" },
      ],
    },
    stats: { eyebrow: "आँकड़ों में", items: [
      { k: "18+", v: "साल का अनुभव" }, { k: "1200+", v: "इंस्टॉलेशन" },
      { k: "50+", v: "गाँव व शहर" }, { k: "100%", v: "ग्राहक स्वीकृत" },
    ]},
    cta: { title: "कुछ टिकाऊ बनाने के लिए तैयार?", sub: "हमें ड्राइंग भेजें या बस विचार।", btn: "प्रोजेक्ट शुरू करें" },
    footer: { rights: "सर्वाधिकार सुरक्षित।", tagline: "स्टील फ़र्नीचर व फैब्रिकेशन · लिंगसुगुर" },
    products: { eyebrow: "कैटलॉग", title: "उत्पाद", sub: "कलेक्शन से फ़िल्टर करें।", all: "सभी", enquire: "पूछताछ" },
    gallery: { eyebrow: "पोर्टफ़ोलियो", title: "गैलरी", sub: "पूर्ण किए गए प्रोजेक्ट्स।" },
    about: { eyebrow: "बारे में", title: "एक वर्कशॉप, एक परिवार, एक कला।",
      p1: "रामदेव स्टील की शुरुआत लिंगसुगुर में एक छोटी वेल्डिंग दुकान से हुई।",
      p2: "स्टील सिर्फ़ सामग्री नहीं — इसमें बनावट, स्मृति और भार है।",
      values: [ { t: "गुणवत्ता", d: "हर जोड़ जांचा जाता है।" }, { t: "टिकाऊ सामग्री", d: "केवल ग्रेडेड स्टील।" },
        { t: "आधुनिक डिज़ाइन", d: "समकालीन ज्यामिति।" }, { t: "ग्राहक पहले", d: "ईमानदार सलाह।" } ],
    },
    notice: { eyebrow: "घोषणाएँ", title: "सूचना बोर्ड", sub: "ऑफ़र, अवकाश और नए उत्पाद।" },
    contact: { eyebrow: "नमस्ते", title: "आइए साथ बनाएँ।", sub: "तेज़ जवाब के लिए व्हाट्सएप।",
      name: "आपका नाम", phone: "फ़ोन नंबर", email: "ईमेल", product: "आवश्यक उत्पाद", message: "अपनी परियोजना बताएं",
      submit: "पूछताछ भेजें", sending: "भेज रहे हैं…",
      success: "पूछताछ प्राप्त। हम जल्द संपर्क करेंगे।", error: "कुछ गड़बड़ हुई। कृपया व्हाट्सएप करें।",
      addressLabel: "वर्कशॉप", phoneLabel: "कॉल", emailLabel: "ईमेल", waLabel: "व्हाट्सएप",
    },
    hours: {
      title: "व्यावसायिक समय",
      openNow: "अभी खुला है", closedNow: "अभी बंद है",
      mondaySaturday: "सोमवार – शनिवार", sunday: "रविवार",
      timeWeekday: "सुबह 9:00 – रात 8:00", timeSunday: "सुबह 9:00 – शाम 8:00",
      note: "नोट: कुछ रविवारों को दुकान बंद रह सकती है। कृपया आने से पहले व्हाट्सएप या कॉल करें।",
    },
    faq: { eyebrow: "प्रश्न", title: "अक्सर पूछे जाने वाले।",
      items: [
        { q: "क्या लिंगसुगुर के बाहर डिलीवर करते हैं?", a: "हाँ — रायचूर, कोप्पल, बल्लारी और आसपास।" },
        { q: "कस्टम गेट में कितना समय?", a: "10–14 कार्य दिवस।" },
        { q: "रखरखाव?", a: "हाँ, वार्षिक सर्विसिंग उपलब्ध है।" },
        { q: "क्या मैं अपना डिज़ाइन दे सकता हूँ?", a: "बिल्कुल, स्केच या फ़ोटो लाइए।" },
      ],
    },
  },
  kn: {
    nav: { home: "ಮುಖಪುಟ", products: "ಉತ್ಪನ್ನಗಳು", gallery: "ಗ್ಯಾಲರಿ", about: "ನಮ್ಮ ಬಗ್ಗೆ", notice: "ಸೂಚನೆ", contact: "ಸಂಪರ್ಕ" },
    hero: {
      eyebrow: "ಸ್ಥಾಪನೆ · ಲಿಂಗಸೂಗೂರು, ಕರ್ನಾಟಕ",
      brand: "ರಾಮದೇವ್ ಸ್ಟೀಲ್ ಫರ್ನಿಚರ್",
      brand2: "ಮತ್ತು ಫ್ಯಾಬ್ರಿಕೇಶನ್",
      sub: "ಸ್ಟೇನ್ಲೆಸ್ ಸ್ಟೀಲ್ ಗೇಟ್‌ಗಳು, ರೇಲಿಂಗ್‌ಗಳು, ಸುರಕ್ಷತಾ ಬಾಗಿಲುಗಳು, ಕಿಟಕಿಗಳು, ಜೋಕಾಲಿಗಳು ಮತ್ತು ಕಸ್ಟಮ್ ಫರ್ನಿಚರ್ — ಲಿಂಗಸೂಗೂರಿನ ನಮ್ಮ ವರ್ಕ್‌ಶಾಪ್‌ನಲ್ಲಿ ತಯಾರಿಸಲಾಗಿದೆ.",
      view: "ಸಂಗ್ರಹಗಳು", whatsapp: "ವಾಟ್ಸಾಪ್", quote: "ಕೋಟ್ ವಿನಂತಿಸಿ",
    },
    slider: { title: "ನಮ್ಮ ಕರಕುಶಲ", sub: "ಇತ್ತೀಚಿನ ಸ್ಥಾಪನೆಗಳು." },
    collections: { eyebrow: "ಸಂಗ್ರಹಗಳು", title: "ಪ್ರತಿ ಸಂಗ್ರಹವನ್ನು ಅನ್ವೇಷಿಸಿ.", view: "ವೀಕ್ಷಿಸಿ", coming: "ಫೋಟೋಗಳು ಶೀಘ್ರದಲ್ಲೇ" },
    marquee: ["ಗೇಟ್", "ರೇಲಿಂಗ್", "ಸುರಕ್ಷತಾ ಬಾಗಿಲು", "ಕಿಟಕಿ", "ಮೆಟ್ಟಿಲು ರೇಲಿಂಗ್", "ಜೋಕಾಲಿ", "ಫರ್ನಿಚರ್", "ಕಸ್ಟಮ್"],
    why: { eyebrow: "ಏಕೆ ರಾಮದೇವ್", title: "ಪ್ರತಿ ವೆಲ್ಡ್‌ನ ಹಿಂದೆ ಆರು ತತ್ವಗಳು.",
      chapters: [
        { t: "ವಸ್ತು ಪ್ರಾಮಾಣಿಕತೆ", d: "ಕೇವಲ ಗ್ರೇಡೆಡ್ MS, SS 304/202 ಬಳಸುತ್ತೇವೆ." },
        { t: "ನಿಖರ ತಯಾರಿಕೆ", d: "CNC ಕಟಿಂಗ್ ಮತ್ತು ಜಿಗ್ ವೆಲ್ಡಿಂಗ್." },
        { t: "ದಶಕಗಳ ಫಿನಿಶ್", d: "ಆಂಟಿ-ರಸ್ಟ್, ಮಿರರ್-ಪಾಲಿಷ್." },
        { t: "ಸೈಟ್-ಫಿಟ್ ಗ್ಯಾರಂಟಿ", d: "ಪ್ರತಿ ಟುಕ್ಡಾ ಡ್ರೈ-ಫಿಟ್ ಮಾಡಲಾಗುತ್ತದೆ." },
        { t: "ಒಂದೇ ವರ್ಕ್‌ಶಾಪ್", d: "ಔಟ್‌ಸೋರ್ಸ್ ಇಲ್ಲ." },
        { t: "ಪಾರದರ್ಶಕ ಬೆಲೆ", d: "ಐಟಮೈಸ್ಡ್ ಕೋಟ್." },
      ],
    },
    stats: { eyebrow: "ಸಂಖ್ಯೆಗಳಲ್ಲಿ", items: [
      { k: "18+", v: "ವರ್ಷಗಳು" }, { k: "1200+", v: "ಸ್ಥಾಪನೆಗಳು" },
      { k: "50+", v: "ಊರುಗಳು" }, { k: "100%", v: "ಗ್ರಾಹಕ ಮೆಚ್ಚಿಗೆ" },
    ]},
    cta: { title: "ಶಾಶ್ವತವಾದ ವಸ್ತು ನಿರ್ಮಿಸಲು ಸಿದ್ಧರೇ?", sub: "ರೇಖಾಚಿತ್ರ ಕಳುಹಿಸಿ.", btn: "ಪ್ರಾಜೆಕ್ಟ್ ಪ್ರಾರಂಭಿಸಿ" },
    footer: { rights: "ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.", tagline: "ಸ್ಟೀಲ್ ಫರ್ನಿಚರ್ · ಲಿಂಗಸೂಗೂರು" },
    products: { eyebrow: "ಕ್ಯಾಟಲಾಗ್", title: "ಉತ್ಪನ್ನಗಳು", sub: "ಸಂಗ್ರಹದಿಂದ ಫಿಲ್ಟರ್.", all: "ಎಲ್ಲಾ", enquire: "ವಿಚಾರಿಸಿ" },
    gallery: { eyebrow: "ಪೋರ್ಟ್‌ಫೋಲಿಯೊ", title: "ಗ್ಯಾಲರಿ", sub: "ಪೂರ್ಣ ಪ್ರಾಜೆಕ್ಟ್‌ಗಳು." },
    about: { eyebrow: "ಬಗ್ಗೆ", title: "ಒಂದು ವರ್ಕ್‌ಶಾಪ್, ಒಂದು ಕುಟುಂಬ.",
      p1: "ರಾಮದೇವ್ ಸ್ಟೀಲ್ ಲಿಂಗಸೂಗೂರಿನಲ್ಲಿ ಆರಂಭವಾಯಿತು.",
      p2: "ಉಕ್ಕು ಕೇವಲ ವಸ್ತು ಅಲ್ಲ — ಅದಕ್ಕೆ ರಚನೆ ಮತ್ತು ಸ್ಮೃತಿ ಇದೆ.",
      values: [ { t: "ಗುಣಮಟ್ಟ", d: "ಪ್ರತಿ ಜೋಡಣೆ ಪರಿಶೀಲನೆ." }, { t: "ಬಾಳಿಕೆ", d: "ಗ್ರೇಡೆಡ್ ಸ್ಟೀಲ್." },
        { t: "ಆಧುನಿಕ ವಿನ್ಯಾಸ", d: "ಸಮಕಾಲೀನ ಜ್ಯಾಮಿತಿ." }, { t: "ಗ್ರಾಹಕ ಮೊದಲು", d: "ಪ್ರಾಮಾಣಿಕ ಸಲಹೆ." } ],
    },
    notice: { eyebrow: "ಪ್ರಕಟಣೆಗಳು", title: "ಸೂಚನಾ ಫಲಕ", sub: "ಆಫರ್‌ಗಳು ಮತ್ತು ಹೊಸ ಬಿಡುಗಡೆಗಳು." },
    contact: { eyebrow: "ಹಲೋ", title: "ಬನ್ನಿ ನಿರ್ಮಿಸೋಣ.", sub: "ವೇಗದ ಪ್ರತಿಕ್ರಿಯೆಗಾಗಿ ವಾಟ್ಸಾಪ್.",
      name: "ನಿಮ್ಮ ಹೆಸರು", phone: "ಫೋನ್", email: "ಇಮೇಲ್", product: "ಅಗತ್ಯ ಉತ್ಪನ್ನ", message: "ನಿಮ್ಮ ಪ್ರಾಜೆಕ್ಟ್",
      submit: "ವಿಚಾರಣೆ ಕಳುಹಿಸಿ", sending: "ಕಳುಹಿಸುತ್ತಿದೆ…",
      success: "ವಿಚಾರಣೆ ಸ್ವೀಕರಿಸಲಾಗಿದೆ.", error: "ಏನೋ ತಪ್ಪಾಗಿದೆ.",
      addressLabel: "ವರ್ಕ್‌ಶಾಪ್", phoneLabel: "ಕರೆ", emailLabel: "ಇಮೇಲ್", waLabel: "ವಾಟ್ಸಾಪ್",
    },
    hours: {
      title: "ವ್ಯವಹಾರ ಸಮಯ",
      openNow: "ಈಗ ತೆರೆದಿದೆ", closedNow: "ಈಗ ಮುಚ್ಚಲಾಗಿದೆ",
      mondaySaturday: "ಸೋಮ – ಶನಿ", sunday: "ಭಾನುವಾರ",
      timeWeekday: "ಬೆಳಗ್ಗೆ 9 – ರಾತ್ರಿ 8", timeSunday: "ಬೆಳಗ್ಗೆ 9 – ಸಂಜೆ 8",
      note: "ಸೂಚನೆ: ಕೆಲವು ಭಾನುವಾರಗಳಂದು ಅಂಗಡಿ ಮುಚ್ಚಿರಬಹುದು. ಬರುವ ಮೊದಲು ವಾಟ್ಸಾಪ್ ಅಥವಾ ಕರೆ ಮಾಡಿ.",
    },
    faq: { eyebrow: "ಪ್ರಶ್ನೆಗಳು", title: "ಸಾಮಾನ್ಯ ಪ್ರಶ್ನೆಗಳು.",
      items: [
        { q: "ಲಿಂಗಸೂಗೂರಿನ ಹೊರಗೆ ಡೆಲಿವರಿ?", a: "ಹೌದು — ರಾಯಚೂರು, ಕೊಪ್ಪಳ, ಬಳ್ಳಾರಿ." },
        { q: "ಕಸ್ಟಮ್ ಗೇಟ್ ಎಷ್ಟು ಸಮಯ?", a: "10–14 ಕೆಲಸದ ದಿನಗಳು." },
        { q: "ನಿರ್ವಹಣೆ?", a: "ಹೌದು, ವಾರ್ಷಿಕ ಸೇವೆ." },
        { q: "ನನ್ನ ಡಿಸೈನ್ ತರಬಹುದೇ?", a: "ಸಂಪೂರ್ಣವಾಗಿ." },
      ],
    },
  },
};

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "hi", label: "हिन्दी", short: "HI" },
  { code: "kn", label: "ಕನ್ನಡ", short: "KN" },
];
